<template>
  <div class="tag">
    <TagSVG /> <span>{{ tag.name }}</span>
  </div>
</template>

<script>
  import TagSVG from '@/components/svg/TagSVG'

  export default {
    components: {
      TagSVG,
    },

    props: {
      tag: { type: Object, default: () => ({}) }
    }
  }
</script>

<style scoped lang="scss">
  .tag {
    display: flex;
    align-items: center;
    border: 1px solid rgba(#000, .3);
    border-radius: 5px;
    padding: 3px 6px;
    text-transform: uppercase;
    transition: .5s all;

    svg {
      width: 12px;
      margin-right: 4px;
      fill: rgba(#000, .8);
    }

    span {
      font-size: 11px;
      color: #000;
    }

    &:hover {
      background: #fff;
    }
  }
</style>
